import moment from "moment";
import { formatDateForRequests } from "utils/HelperFunctions";

export const yesterday = (selectedDate) => {
  return selectedDate.clone().subtract(1, "day")
}

export const tomorrow = (selectedDate) => {
  return selectedDate.clone().add(1, "day")
}

export const lastMonth = (selectedDate) => {
  return selectedDate.clone().subtract(1, "month")
}

export const nextMonth = (selectedDate) => {
  return selectedDate.clone().add(1, "month")
}

export const lastWeek = (selectedDate) => {
  return selectedDate.clone().subtract(1, "week").startOf('day')
}

export const nextWeek = (selectedDate) => {
  return selectedDate.clone().add(1, "week")
}

export const lastThreeWeeks =
  moment().subtract(3, "week").format().toString().split("+")[0] + "Z";

// * Get current and previous 3 weeks data
export const lastFourWeeks =
  moment().clone().weekday(1).subtract(3, "week")


// * Get current and previous 5 months data
export const lastSixMonths =
  moment().startOf('month').subtract(5, "month")

// * Get current and previous months of data
export const lastTwoMonths =
  moment().startOf('month').subtract(1, "month")

export const lastYearsPerMonth=
  moment().startOf('month').subtract(120, "month")
  
// *  Get current and previous years of data 
export const lastYears =
  moment().subtract(10, "years").format().toString().split("+")[0] + "Z";

export const ParametersTypes = {
  HEARTPULSE_LAST_TWO_MONTHS: {
    type: "HEARTPULSE",
    name: "HR",
    startDate: formatDateForRequests(lastTwoMonths),
    endDate: formatDateForRequests(moment()),
  },
  HEARTPULSE_LAST_YEARS_PER_MONTH: {
    type: "HEARTPULSE",
    name: "HR",
    startDate: formatDateForRequests(lastYearsPerMonth),
  },
  HEARTPULSE_LAST_MONTH: {
    type: "HEARTPULSE",
    name: "HR",
    startDate: formatDateForRequests(lastMonth(moment())),
  },
  HEARTPULSE_LAST_WEEK: {
    type: "HEARTPULSE",
    name: "HR",
    startDate: formatDateForRequests(lastWeek(moment())),
  },
  HEARTPULSE_LAST_YEARS: {
    type: "HEARTPULSE",
    name: "HR",
    startDate:lastYears,
  },
  HEARTPULSE_HOUR_IN_DAY: {
    type: "HEARTPULSE_HOUR_IN_DAY",
    name: "HR",
  },
  HEARTPULSE_DAY_IN_MONTH: {
    type: "HEARTPULSE_DAY_IN_MONTH",
    name: "HR",
  },
  HEARTPULSE_INTENSITY: {
    type: "HEARTPULSE_INTENSITY",
    name: "HR",
  },
  WEIGHT: {
    type: "WEIGHT",
    name: "WEIGHT",
  },
  STEPS_LAST_TWO_MONTHS: {
    type: "STEPS_LAST_TWO_MONTHS",
    name: "STEPS",
    startDate: formatDateForRequests(lastTwoMonths),
    endDate: formatDateForRequests(moment()),
    aggregation: "BY_DAY",
  },
  STEPS_AVERAGE: {
    type: "STEPS_AVERAGE",
    name: "STEPS",
    aggregation: "BY_DAY",
  },
  STEPS_DAY_IN_MONTH: {
    type: "STEPS_DAY_IN_MONTH",
    name: "STEPS",
    aggregation: "BY_DAY",
  },
  STEPS_HOUR_IN_DAY: {
    type: "STEPS_HOUR_IN_DAY",
    name: "STEPS",
  },
  STEPS_LAST_MONTHS: {
    type: "STEPS_LAST_TWO_MONTHS",
    name: "STEPS",
    startDate: formatDateForRequests(lastYearsPerMonth),
    endDate: formatDateForRequests(moment()),
    aggregation: "BY_DAY",
  },
  STEPS_LAST_SIX_MONTHS: {
    type: "STEPS_LAST_SIX_MONTHS",
    name: "STEPS",
    startDate: formatDateForRequests(lastSixMonths),
    endDate: formatDateForRequests(moment()),
    aggregation: "BY_DAY",
  },
  STEPS_LAST_THREE_WEEKS: {
    type: "STEPS_LAST_THREE_WEEKS",
    name: "STEPS",
    startDate: lastThreeWeeks,
    endDate: formatDateForRequests(moment()),
  },
  STEPS_LAST_YEARS: {
    type: "STEPS_LAST_YEARS",
    name: "STEPS",
    startDate: lastYears,
    endDate: formatDateForRequests(moment()),
  },
  SLEEP: {
    type: "SLEEP",
    name: "SLEEP",
    startDate: formatDateForRequests(lastMonth(moment())),
    aggregation: "BY_DAY",
  },
  CALORIES_LAST_THREE_WEEKS: {
    type: "CALORIES_LAST_THREE_WEEKS",
    name: "CALORIES",
    startDate: formatDateForRequests(lastMonth(moment())),
  },
  CALORIES_LAST_TWO_MONTHS: {
    type: "CALORIES_LAST_TWO_MONTHS",
    name: "CALORIES",
    startDate: formatDateForRequests(lastTwoMonths),
    endDate: formatDateForRequests(moment()),
  },
  CALORIES_LAST_YEARS: {
    type: "CALORIES_LAST_YEARS",
    name: "CALORIES",
    startDate: lastYears,
  },
};
